
import { faCircleUser } from "@fortawesome/free-regular-svg-icons"
import { faAddressCard, faCheck, faPaperPlane, faTrash, faUserGear, faX } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useState } from "react"
import { ManageUser } from "../../../../../redux/slices/components/ManageUsers/manageUsersDataSlice"
import { addUserGroupedReducer, removeUserGroupedReducer } from "../../../../../redux/slices/components/ManageUsers/manageUsersGroupedDataSlice"
import { setDeleteUserModalStateReducer, setEditUserRoleModalStateReducer, setSendMessageUserModalStateReducer } from "../../../../../redux/slices/components/ManageUsers/manageUsersModalsSlice"
import { useAppDispatch } from "../../../../../redux/store/store"
import { getProfilePictureByUserId } from "../../../../../utils/requestsUtils/functionsRequests/user/userFunctions"
import useCheckAccess from "../../../../hooks/useCheckAccess/useCheckAccess"
import "./RowTableUsers.css"
import UsersINE from "./UsersINE/UsersINE"
import moment from 'moment';
import { capitalize } from "lodash"


interface RowTableUsersProps {
    user: ManageUser
    checkboxValue: boolean
}

const RowTableUsers = ({ user, checkboxValue }: RowTableUsersProps) => {

    const dispatch = useAppDispatch()
    const [showIneImage, setShowIneImage] = useState(false)
    const [userImg, setUserImg] = useState<string>("")

    const accessDisplay = useCheckAccess({ id_Category: "Manage_Users", id_Policy: "Users", id_Action: "Display" })
    const accessSendMessage = useCheckAccess({ id_Category: "Manage_Users", id_Policy: "Message", id_Action: "Edit" })
    const accessEditUserRole = useCheckAccess({ id_Category: "Manage_Users", id_Policy: "Users", id_Action: "Edit" })
    const accessDeleteUser = useCheckAccess({ id_Category: "Manage_Users", id_Policy: "Users", id_Action: "Delete" })

    useEffect(() => {
        getProfilePictureByUserId(user.id, "small")
        .then((imgUrl) => {
            setUserImg(imgUrl)
        }).catch(() => {
            
        })
        return () => {}
    }, [])

    const handleUserCheckbox = (event: any) => {
        event.stopPropagation(); // prevent event from bubbling up
        // These two lines avoid to select the row when we click in open menu or delete job
        const styleClasses: string = event.target.className.baseVal ?? event.target.className ?? ""
        const styleClassesParent: string = event.target.parentNode.className.baseVal ?? event.target.parentNode.className ?? ""

        if(styleClasses.indexOf("no-select") > -1 || styleClassesParent.indexOf("no-select") > -1)
            return

        if(!checkboxValue){
            dispatch(addUserGroupedReducer(
                user
            ))
        }else{
            dispatch(removeUserGroupedReducer({
                id: user.id
            }))
        }
    }
    
    const handleSendMessage = (event: any) => {
        event.stopPropagation(); // prevent event from bubbling up
        dispatch(setSendMessageUserModalStateReducer({
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            mail: user.mail
        }))
    }

    const handleEditUserRole = (event: any) => {
        event.stopPropagation(); // prevent event from bubbling up
        dispatch(setEditUserRoleModalStateReducer(user))
    }

    const handleDeleteUser = (event: any) => {
        event.stopPropagation(); // prevent event from bubbling up
        dispatch(setDeleteUserModalStateReducer({
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName
        }))
    }

    const handleDisplayINE = (event: any) => {
        event.stopPropagation(); // prevent event from bubbling up
        setShowIneImage(true)
    }

    const hideINE = (event: any) => {
        event.stopPropagation(); // prevent event from bubbling up
        setShowIneImage(false)
    }

    let hour = ""
    let day = ""
    if(user.register_activity){
        hour = moment(user.register_activity).format("HH:mm a")
        day = moment(user.register_activity).format("DD MMMM YYYY")
    }

    return (
        <div id={`user-row-${user.id}`}  className={`con-row-user con-row width-100 flex fw-500 pointer ${checkboxValue ? "blue-row-background" : ""}`}>

            <button onClick={handleUserCheckbox} className="item1-table-user center">
                <input 
                    type="checkbox" 
                    className="pointer" 
                    onChange={() => {}}
                    checked={checkboxValue}
                />
            </button>
            
            <div className="item2-table-user center-start">
                <img 
                    onClick={handleEditUserRole}
                    className="img-circular-row circle pointer" 
                    src={userImg}
                    alt="user"
                    onError={(e) => { 
                        (e.target as HTMLImageElement).src = "/assets/images/profilePic.png" 
                    }}
                />
            </div>

            <div className="item3-table-user center-start">
                <p onClick={handleEditUserRole} className="fs-12 fs-600 three-dot pr-8 pointer" title={user.id}>{user.id}</p>
            </div>

            <div className="item4-table-user center-start">
                <p className="fs-13 fs-600">{user.lastName}</p>
            </div>

            <div className="item5-table-user center-start">
                <p className="fs-13 fs-600">{user.firstName}</p>
            </div>

            <div className="item6-table-user center-start">
                <p className="fs-13 fs-600">{user.roleId}</p>
            </div>

            <div className="item8-table-user center-start">
                <p className="fs-13 fs-600">{`${hour} - ${day}`}</p>
            </div>

            <div className="item9-table-user center">
                <p className="color-gimmer">
                    {user.GimmerTransactionsFinished}
                </p>
            </div>

            <div className="item10-table-user center">
                <p className="color-gim">
                    {user.GimTransactionsFinished}
                </p>
            </div>

            <div className="flex flex-1 flex-ai-center flex-jc-end">
                {
                    accessSendMessage &&
                    <button onClick={handleSendMessage} type="button" className="center pointer bg-transparent mr-6 circle hover-bg-gray-icon icon-user-row no-select">
                        <FontAwesomeIcon icon={faPaperPlane} className="fs-14 no-select" />
                    </button>
                }
                {
                    accessEditUserRole &&
                    <button onClick={handleEditUserRole} type="button"  className="center pointer bg-transparent mr-6 ml-6 circle hover-bg-gray-icon icon-user-row no-select">
                        <FontAwesomeIcon icon={faUserGear} className="fs-14 no-select" />
                    </button>
                }
                {
                    accessDeleteUser &&
                    <button onClick={handleDeleteUser} type="button"  className="center pointer bg-transparent ml-6 mr-6 cirlce hover-icon-red icon-user-row no-select">
                        <FontAwesomeIcon icon={faTrash} className="fs-14 no-select" />
                    </button>
                }
                {
                    accessDisplay &&
                    <FontAwesomeIcon icon={user.isIdVerified ? faCheck : faX} className="fs-14" style={{ width: "2rem", color: user.isIdVerified ? "green" : "red" }}  />
                }
                {
                    accessDisplay &&
                    <button 
                        onClick={handleDisplayINE} 
                        type="button"  
                        className="center pointer bg-transparent ml-6 circle hover-bg-gray-icon icon-user-row"
                    >
                        <FontAwesomeIcon icon={faAddressCard} className="fs-14 no-select" style={{ color: user.isIdUploaded ? "green" : "red" }} />
                    </button>
                }

                {
                    accessDisplay &&
                    <FontAwesomeIcon icon={faCircleUser} className="fs-14 ml-6" style={{ width: "2rem", color: user.isProfilePicUploaded ? "green" : "red" }}  />
                }

                {
                    accessDisplay &&
                    <p className="fs-14 ml-8" style={{ color: user.Tax_Information ? "green" : "red" }}>{"TAX"}</p>
                }

                {
                    accessDisplay &&
                    <p className="fs-14 ml-8 mr-10" style={{ color: user.nss_information ? "green" : "red" }}>{"NSS"}</p>
                }
                
            </div>
            {
                showIneImage &&
                <UsersINE id={user.id} closeImage={hideINE} />
            }
        </div>
    )
}

export default React.memo( RowTableUsers )